import "../Main.css";

const PrivacyPolicy = () => {
    return (
        <div className="p-3"><h1>Privacy Policy for IntRating.net</h1>
            <p>This Privacy Policy describes how IntRating.net ("we", "us", or "our") collects, uses, and discloses personal information when you use our website (the "Service").</p>
            
            <h2>Information We Collect</h2>
            <ul>
                <li><strong>Location Data and Session Time:</strong> We collect location data and session time through the use of Google Analytics for the purpose of understanding the geographic distribution and usage patterns of our users. This information helps us improve our services and better cater to our users' needs.</li>
                <li><strong>Email and Password:</strong> Upon sign-up, we collect users' email addresses and passwords. The email address is used solely for login purposes and will never be used for marketing or newsletters. Passwords are securely hashed in our database for user account security.</li>
                <li><strong>Cookies:</strong> We use cookies to track user sessions and determine if a user is logged in. These cookies do not directly collect any personal information about the user.</li>
            </ul>
            
            <h2>Use of Information</h2>
            <p>We use the information collected, including location data, session time, email addresses, and passwords, to provide and improve our services, customize user experiences, and ensure the security of user accounts.</p>
            
            <h2>Data Retention</h2>
            <p>We retain user data until the user requests its deletion. Since we do not track user login activity, we rely on user requests to deactivate and delete unused accounts.</p>
            
            <h2>Third-Party Services</h2>
            <p>We use Google Analytics to collect location data and session time. Please refer to Google's Privacy Policy for information on how Google collects and uses data.</p>
            
            <h2>Data Sharing and Disclosure</h2>
            <p>We do not sell or directly share our users' personal information with third parties. All personal information collected remains confidential unless required by law enforcement or legal authorities.</p>
            
            <h2>User Rights</h2>
            <p>Users have the right to request access to, update, or delete their personal information by contacting us at <a href="mailto:intratingofficial@gmail.com">intratingofficial@gmail.com</a>. Upon request, we will provide users with all data collected on them.</p>
            
            <h2>Contact Information</h2>
            <p>If you have any questions or concerns about our Privacy Policy, please contact us at <a href="mailto:intratingofficial@gmail.com">intratingofficial@gmail.com</a>.</p>
            
            <h2>Changes to this Privacy Policy</h2>
            <p>We reserve the right to update or modify this Privacy Policy at any time. Any changes will be effective immediately upon posting on our website.</p>
            
            <p>By using our website, you agree to the terms of this Privacy Policy.</p>
            
            <p>Last Updated: 02/02/2024</p>
        </div>
    );
};

export default PrivacyPolicy;
